import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Logo from "../../components/Logo";
import CustomerRegisterForm from "../../components/auth/CustomerRegisterForm";
import { useAuthActions } from "../../features/auth/useAuthActions";
import { useOTP } from "../../features/auth/useOTP";

export default function CustomerRegisterPage() {
  const { register } = useAuthActions();
  const { requestOTP } = useOTP();
  const [loading, setLoading] = useState(false);
  const [globalError, setGlobalError] = useState("");
  const navigate = useNavigate();

  // تکمیل ثبت‌نام پس از پر کردن تمام فیلدها و تایید OTP
  const handleRegisterSubmit = async (formData) => {
    setLoading(true);
    setGlobalError("");
    try {
      await register(formData);
      navigate("/"); // بازگشت به صفحه قبلی پس از تکمیل موفق ثبت نام و لاگین خودکار
       window.location.reload();
    } catch (error) {
      console.error("Registration failed:", error);
      if (error.response?.status === 400) {
        setGlobalError(error.response.data.detail || "اطلاعات نامعتبر است. تکرار رمز عبور یا کد OTP را بررسی کنید.");
      } else {
        setGlobalError("ثبت نام ناموفق بود. احتمالاً شماره موبایل تکراری است.");
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // هندل کردن ارسال پیامک OTP بدون تغییر استیت صفحه
  const handleOTPRequest = async (phoneNumber, purpose) => {
    setGlobalError("");
    try {
      const res = await requestOTP(phoneNumber, purpose);
      return res;
    } catch (error) {
      console.error("OTP Request failed:", error);
      if (error.response?.status === 429) {
        setGlobalError("تعداد درخواست‌های پیامک بیش از حد مجاز است. کمی صبر کنید.");
      } else {
        setGlobalError(error.response?.data?.detail || "ارسال پیامک با خطا مواجه شد.");
      }
      throw error;
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4 py-8">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md border">

        {/* هدر صفحه */}
        <div className="mb-6 text-center relative">
          <Link to="/">
            <Logo />
          </Link>
          <h1 className="text-xl font-medium mt-2">ثبت نام مشتری</h1>
          <Link to="/">
            <FaArrowRight className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-800" />
          </Link>
        </div>

        {/* فرم یکپارچه ثبت‌نام */}
        <CustomerRegisterForm
          onRegister={handleRegisterSubmit}
          onRequestOTP={handleOTPRequest}
          isLoading={loading}
        />

        {/* خطاهای سرور */}
        {globalError && <p className="text-red-600 text-sm mt-4 text-center">{globalError}</p>}

        {/* لینک مستقیم به صفحه ورود */}
        <div className="flex flex-col items-center gap-1 mt-6 text-sm border-t pt-4">
          <span className="text-gray-500">قبلاً ثبت نام کرده‌اید؟</span>
          <Link to="/user-login" className="text-blue-600 hover:underline font-semibold">
            ورود به حساب کاربری
          </Link>
        </div>

        {/* قوانین سایت */}
        <p className="text-xs text-center text-gray-500 mt-4">
          ثبت‌نام شما به معنای پذیرش{" "}
          <span className="text-blue-600 font-semibold cursor-pointer">شرایط مارکت پلیس</span>
          {" "}و{" "}
          <span className="text-blue-600 font-semibold cursor-pointer">قوانین حریم خصوصی</span>
          {" "}است.
        </p>
      </div>
    </div>
  );
}
